import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LogoutIcon, NavPasswordIcon, NavProfileIcon } from '../../theme/SvgIcons';
import UpdatePassword from '../../modules/employees/view-employee/modals/UpdatePassword';
import styled from '@emotion/styled';
import ActiveDevices from './ActiveDevices';
import { LinkOutlined } from '@ant-design/icons';

function Logout({ loggedUser, setIsLogoutOpen, setOpenLogoutModal, closePopover }) {
  const navigate = useNavigate();
  const [passwordModal, setPasswordModal] = useState(false);
  const { isEmployee } = useSelector((state) => state?.userInfo) || {};
  const handleOpenModal = () => setOpenLogoutModal(true);
  const [isOpenDeviceModal, setIsOpenDeviceModal] = useState(false);

  return (
    <>
      {isEmployee && (
        <StyleBox
          onClick={() => {
            navigate(`my-profile`, { state: { id: loggedUser } });
            setIsLogoutOpen(false);
            if (closePopover) closePopover();
          }}>
          <NavProfileIcon />
          My Profile
        </StyleBox>
      )}

      <StyleBox
        onClick={() => {
          setPasswordModal(true);
          if (closePopover) closePopover();
        }}>
        <NavPasswordIcon />
        Change Password
      </StyleBox>

      <StyleBox
        onClick={() => {
          handleOpenModal();
          if (closePopover) closePopover();
        }}>
        <LogoutIcon />
        Logout
      </StyleBox>

      {!isEmployee && (
        <StyleBox
          onClick={() => {
            setIsOpenDeviceModal(true);
            if (closePopover) closePopover();
          }}>
          <LinkOutlined style={{ fontSize: '16px' }} />
          Active Devices
        </StyleBox>
      )}
      {passwordModal && (
        <UpdatePassword open={passwordModal} onClose={() => setPasswordModal(false)} />
      )}

      {isOpenDeviceModal && (
        <ActiveDevices open={isOpenDeviceModal} onClose={() => setIsOpenDeviceModal(false)} />
      )}
    </>
  );
}
Logout.propTypes = {
  loggedUser: PropTypes.string,
  setIsLogoutOpen: PropTypes.func,
  setOpenLogoutModal: PropTypes.func,
  closePopover: PropTypes.func
};
export default Logout;

const StyleBox = styled.button`
  background: inherit;
  cursor: pointer;
  gap: 10px;
  padding: 12px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 24px auto;
  gap: 5px;
  align-items: center;
  border: none;
  width: 100%;
  text-align: start;
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0e0e0e;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColor};
    color: white;
  }
`;
